import { TOOL_GROUP_THRESHOLD } from '../../constants';
import { scrollToBottom } from './scrollbar';
import { clearStreamingPlaceholder, getStreamingBubble, getStreamingContentTail } from './streaming';
import { createToolCallElement, createToolGroupElement, refreshToolGroupSummary, updateToolCallElement } from './tool-elements';
import type { ToolCallSegment } from './types';

export function appendToolCall(
  toolUseId: string,
  name: string,
  input: unknown,
  done: boolean,
  kind: string | null = null,
  meta: unknown = null,
): void {
  const bubble = getStreamingBubble();
  if (!(bubble instanceof HTMLElement)) return;
  clearStreamingPlaceholder(bubble);
  const metaEl = bubble.querySelector('.msg-meta-bar');
  const tool: ToolCallSegment = { id: toolUseId, name, input, kind, meta: (meta && typeof meta === 'object' ? meta as Record<string, unknown> : null), done };
  const details = createToolCallElement(toolUseId, tool, done);
  const trailingCluster: Element[] = [];
  for (let node = getStreamingContentTail(bubble); node; node = node.previousElementSibling) {
    if (node.classList.contains('tool-call') || node.classList.contains('tool-group')) {
      trailingCluster.unshift(node);
      continue;
    }
    break;
  }
  const trailingGroup = trailingCluster.length === 1 && trailingCluster[0].classList.contains('tool-group')
    ? trailingCluster[0]
    : null;
  if (trailingGroup) {
    trailingGroup.querySelector('.tool-group-inner')?.appendChild(details);
    refreshToolGroupSummary(trailingGroup);
  } else if (trailingCluster.length + 1 >= TOOL_GROUP_THRESHOLD) {
    const group = createToolGroupElement([]);
    if (trailingCluster[0]) bubble.insertBefore(group, trailingCluster[0]);
    else if (metaEl) bubble.insertBefore(group, metaEl);
    else bubble.appendChild(group);
    const inner = group.querySelector('.tool-group-inner');
    trailingCluster.forEach((child) => inner?.appendChild(child));
    inner?.appendChild(details);
    refreshToolGroupSummary(group);
  } else {
    if (metaEl) bubble.insertBefore(details, metaEl);
    else bubble.appendChild(details);
  }
  scrollToBottom();
}

export function updateToolCall(toolUseId: string, result: unknown): void {
  updateToolCallElement(toolUseId, result);
}
